import React from 'react';
import { render } from 'react-dom';
import './static/css/main.scss'; // 全局样式
import Base from './base';
// import VConsole from 'vconsole';

import App from './app';

const root = document.getElementById('root');
Base.topbar();
// process.env.REACT_APP_LOCAL && new VConsole();
const load = () => render(
    <App />
  ,
  root,
);

if (module.hot) {
  module.hot.accept('./app', load);
}

load();
